<template>
  <div>
    <file-upload-dnd
      class="mx-auto"
      :accepted-files="{
        PDF: 'application/pdf',
        Image: 'image/*'
      }"
      :dropzone-options="dropzoneOptions"
      title="Upload W9"
      @input="fileId = $event"
    >
    </file-upload-dnd>
    <div class="text-right mt-6">
      <v-btn
        text
        class="text-decoration-underline mr-2"
        href="fw9_2026.pdf"
        download
      >
        Download a Fillable W-9
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!fileId"
        @click="
          logEvent('Clicked button to upload file', { Where });
          submit();
        "
        :loading="uploading"
        >Upload File</v-btn
      >
    </div>
  </div>
</template>

<script>
import FileUploadDnd from "@/components/FileUploadDnd";
import { w9API } from "@/services/api";
import { post } from "@/services/request";
import hasNotifications from "@/mixins/has-notifications";

const dropzoneOptions = {
  url: "/services/files",
  headers: {
    "user-type": "vendor",
    "directory-name": "w9"
  }
};

export default {
  name: "W9Upload",
  mixins: [hasNotifications],
  data: () => ({
    fileId: null,
    dropzoneOptions,
    uploading: false
  }),
  inject: ["nav", "Where"],
  methods: {
    submit() {
      this.uploading = true;
      const fileId = this.fileId;

      post(w9API, null, { fileId })
        .then(
          () => {
            console.log("W9 submit successful, fileId: ", fileId);
            this.showMessage("You've successfully uploaded your W-9");
            this.$emit("w9saved", true);
            this.nav.w9Table();
          },
          () => console.error("w9 submit failed, fileId: ", fileId)
        )
        .then(() => (this.uploading = false));
    }
  },
  components: {
    FileUploadDnd
  }
};
</script>

<style lang="sass" scoped>
.v-btn
  font-size: 1rem
  &.v-btn--text
    font-weight: 600
    color: $subtitle
</style>
